import React, { useState, useEffect, Fragment } from "react";
import { DataGrid } from '@mui/x-data-grid';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import EditIcon from '@mui/icons-material/Edit';
import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import { Stack, Alert, Collapse } from '@mui/material';
//import Profile from "./Profile";
import { useAuth0 } from "@auth0/auth0-react";
import CustomToolbar from "./Widgets/CustomToolbar";
import VendorRequestDialog from "./VendorRequest";
import SuccessError from "./Widgets/SuccessError";
import DarkBackground from "./Widgets/TransparentLoadingDisplay";
import LoadingOverlay from "react-loading-overlay";
import VendorRequestHistoryCard from "./Widgets/VendorRequestHistoryCard";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { Mail } from "@mui/icons-material";
import { FormControl, InputLabel, Select, MenuItem, FormGroup, FormControlLabel } from "@mui/material";
import Checkbox from '@mui/material/Checkbox';
import { Controller } from "react-hook-form";
import MultiSelectWithChips from "./Widgets/MultiSelectWithChips";
import { set } from "date-fns";
import { da, de } from "date-fns/locale";
import _without from "lodash/without";
import { useSearchParams } from "react-router-dom";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';



var reRender = 1;

const useAsyncLoad = (url, anonymous) => {

  const [errorA, setErrorA] = useState(null);
  const [loading, setLoading] = useState(true);
  const [vendors, setVendors] = useState(null);
  
  const x = reRender;

  async function GetDataUserData(url) {

    if (!anonymous) {
      //const audience = 'https://piaapplication.azurewebsites.net/';

      // const accessToken = await getAccessTokenSilently({
      //   audience: audience,
      //   //scope: "read:messages",
      // });

      // var bearer = 'Bearer ' + accessToken;

      const accessToken = localStorage.getItem("userToken");

      var userData = await fetch(url, {
        method: 'GET',
        withCredentials: !anonymous,
        credentials: 'include',
        headers: {
          'Authorization': accessToken,
          'Content-Type': 'application/json'
        }
      });

      var data = await userData.json();

      data.accessToken = accessToken;
      //console.log(data);
      return data;
    }
    else {
      var userData = await fetch(url, {
      });

      var data = await userData.json();
      //console.log(data);
      return data;
    }
    //return data;
  };


  async function loadData(url) {

    try {

      setErrorA(null);
      if (x < 2) {
        setLoading(true);
      }

      var data = await GetDataUserData(url);

      setVendors(data);
      //console.log(data);

    } catch (e) {
      setLoading(false);
      setErrorA(e);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    loadData(url);
    // eslint-disable-next-line
  }, [x]);

  return [vendors, errorA, loading];
}


const FetchRecords = () => {
  const [value, error, loading] = useAsyncLoad("datausers/getdatausers", false);
  return [value, error, loading];
}
const FetchRecord = (id) => {
  debugger;
  const [searchParams, setSearchParams] = useSearchParams();
  var tenant = searchParams.get('tenantId');

  const [value, error, loading] = useAsyncLoad("public/getdatauseranonymous?id=" + id+"&tenantId="+tenant, true);

  return [value, error, loading];
}

export default function DataTable() {

  const [open, setOpen] = React.useState(false);
  const [editOpen, setEditOpen] = React.useState(false);
  const [deleteOpen, setDeleteOpen] = React.useState(false);
  const [deleteName, setDeleteName] = React.useState('');
  const [deleteId, setDeleteId] = React.useState('');
  const [successOpen, setSuccessOpen] = React.useState(false);
  const [errorOpen, setErrorOpen] = React.useState(false);
  const [errorDialogOpen, setErrorDialogOpen] = React.useState(false);
  const [successMessage, setSuccessMessage] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState(false);
  const [editOrAddTitle, setEditOrAddTitle] = React.useState('');
  const [accessToken, setAccessToken] = useState();
  const [departments, setDepartments] = useState([]);
  const [dataSystems, setDataSystems] = useState([]);
  const [generalOpen, setGeneralOpen] = useState(true);
  const [systemAccessOpen, setSystemAccessOpen] = useState(true);
  const [dataAccessOpen, setDataAccessOpen] = useState(false);
  const [dataTypesSelected, setDataTypesSelected] = useState([]);
  const [dataTypesItems, setDataTypesItems] = useState([]);
  const [dataSignoff, setDataSignOff] = React.useState(false);
  const [newAccessRecords, setNewAccessRecords] = React.useState([]);
  const [filt, setFilt] = useState([])
  const [searchParams] = useSearchParams();
  const [declarationOpen, setDeclarationOpen] = React.useState(false);




  const requestCode = searchParams.get("id"); //this is the id of the data user declaration/request

  const UrlRe = RegExp('(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?');

  const validationSchema = Yup.object().shape({
    id: Yup.number(),
    firstName: Yup.string()
      .required('First Name is required')
      .max(150, 'First Name must not exceed 150 characters'),
    lastName: Yup.string()
      .required('Last Name is required')
      .max(150, 'Last Name must not exceed 150 characters'),
    email: Yup.string()
      .required('Email is required')
      .email('Email is invalid')
      .max(250, 'Email must not exceed 250 characters'),
    departmentId: Yup.number()
      .required('Department is required'),
    // dataSystemId: Yup.number()
    //   .required('System and Module is required'),
    dataUse: Yup.string()
      //.required('Last Name is required')
      .max(500, 'Data Use must not exceed 500 characters'),
    dataRetention: Yup.string()
      //.required('Last Name is required')
      .max(500, 'Data Retention must not exceed 500 characters'),

    dataSignoff: Yup.boolean()


  });

  const validationSchemaSystemAccess = Yup.object().shape({
    id: Yup.number(),
    dataSystemId: Yup.number()
      .required('System and Module is required'),
    dataUse: Yup.string()
      //.required('Last Name is required')
      .max(500, 'Data Use must not exceed 500 characters'),
    dataRetention: Yup.string()
      //.required('Last Name is required')
      .max(500, 'Data Retention must not exceed 500 characters'),

    dataSignoff: Yup.boolean()
  });

  const handleDataTypesChange = (event) => {
    const {
      target: { value },
    } = event;
    setDataTypesSelected(typeof value === 'string' ? value.split(',') : value,);
  };

  const handleChipDeleteForDataTypes = (event, value, stateFunction) => {
    event.preventDefault();
    stateFunction((current) => _without(current, value));
    // if (value === 'Other') {
    //   setotherDepartmentsShow(false);
    // }
  };

  const handleDataSignOffChange = (event) => {
    setDataSignOff(event.target.checked);
  };
  const onSubmit = data => {

    if (data.id === -1) {
      saveDataUser(data, 'Add', accessToken);
    } else {
      saveDataUser(data, 'Save', accessToken);
    }
    setEditOpen(false);
  };

  const onSubmitComplete = data => {
    debugger;
    data.completionStatus = 2; //complete
    data.dataSignoff = dataSignoff;
    if (dataSignoff === false) {
      showErrorDialog("You must agree to the data privacy policy sign off to complete the declaration");
      return;
    }
    saveDataUser(data, 'Save', accessToken);

    setEditOpen(false);
  };

  const onSubmitInProgress = data => {
    if (dataSignoff === false) {
      showErrorDialog("You must agree to the data privacy policy sign off to complete the declaration");
      return;
    }
    data.completionStatus = 1; //in progress
    data.dataSignoff = dataSignoff;
    saveDataUser(data, 'Save', accessToken);

    setEditOpen(false);
  };




  const onSubmitSystemAccess = data => {
    //has to be saved in memory at this point
    var dataSystemDisplay = recordData.dataSystems.find(x => x.id === data.dataSystemId).system;
    var moduleDisplay = recordData.dataSystems.find(x => x.id === data.dataSystemId).module;
    dataSystemDisplay = dataSystemDisplay + ' - ' + moduleDisplay;

    if (data.systemAccessId === -1) { //add
      //save to temp array
      //find the smallest id in dataSystemUsers array and subtract 1
      var newId = -1;
      if (recordData.dataSystemUsers.length > 0) {
        var minId = Math.min.apply(Math, recordData.dataSystemUsers.map(function (o) { return o.id; }));
        if (minId < 0) {
          newId = minId - 1;
        }
      }

      var itemToAdd = {
        id: newId,
        dataUserId: data.id,
        dataSystemId: data.dataSystemId,
        dataUse: data.dataUse,
        dataRetention: data.dataRetention,
        selectedDataTypes: dataTypesSelected,
        dataSignoff: dataSignoff,
        dataSystemName: dataSystemDisplay
      }
      setNewAccessRecords([...newAccessRecords, itemToAdd]);
      //add to the grid
      recordData.dataSystemUsers = [...recordData.dataSystemUsers, itemToAdd];
    } else { //updating
      //find the item in the array and update it

      var itemToUpdate = recordData.dataSystemUsers.find(x => x.dataUserId === data.id);
      if (itemToUpdate) {
        itemToUpdate.dataSystemId = data.dataSystemId;
        itemToUpdate.dataUse = data.dataUse;
        itemToUpdate.dataRetention = data.dataRetention;
        itemToUpdate.selectedDataTypes = dataTypesSelected;
        itemToUpdate.dataSignoff = dataSignoff;
        itemToUpdate.dataSystemName = dataSystemDisplay;
      }


    }
    setDataAccessOpen(false);
  };
 

  const handleDataSignoffChange = () => {
    setValueSystemAccess('dataSignoff', !dataSignoff);
    setValue('dataSignoff', !dataSignoff);
    setDataSignOff(!dataSignoff);
  };

  const showSuccess = message => {
    setSuccessOpen(true);
    setSuccessMessage(message);
    setTimeout(() => setSuccessOpen(false), 3000);
  };

  const showError = message => {
    setErrorOpen(true);
    setErrorMessage(message);
    setTimeout(() => setErrorOpen(false), 3000);
  };

  const showErrorDialog = message => {
    setErrorDialogOpen(true);
    setErrorMessage(message);
    setTimeout(() => setErrorDialogOpen(false), 3000);
  };

  const setUserValues = (dataRow) => {
    setValue("id", dataRow.id);
    setValue("firstName", dataRow.firstName);
    setValue("lastName", dataRow.lastName);
    setValue("email", dataRow.email);
    setValue("departmentId", dataRow.departmentId);
    setEditOrAddTitle('Edit Declaration For ');
  };

  async function saveDataUser(dataUser, saveOrAddOrDelete, accessToken) {

    var method = '';
    var url = ''
    if (saveOrAddOrDelete === 'Add') {
      method = 'POST';
      url = 'datausers/';
    } else if (saveOrAddOrDelete === 'Save') {
      method = 'PUT';
      if (requestCode === null) {
        url = 'datausers/' + dataUser.id;
      } else {

        url = 'datausers/saveanon';
      }
    }
    else if (saveOrAddOrDelete === 'Delete') {
      method = 'DELETE';
      url = 'datausers/' + dataUser.id;
    }
    else if (saveOrAddOrDelete === 'Send') {
      method = 'POST';
      url = 'datausers/senddeclaration';
    }
    else if (saveOrAddOrDelete === 'SendAll') {
      method = 'GET';
      url = 'datausers/sendalldeclarations';
    }


    var bearer = localStorage.getItem("userToken");

    if (dataUser) {
      dataUser.dataSystemUsers = recordData.dataSystemUsers; //all of these will need to be saved
    }


    try {
      var requestOptions = {};
      if (method === 'GET') {
        requestOptions = {
          method: method,
          withCredentials: true,
          credentials: 'include',
          headers: {
            'Authorization': bearer,
            'Content-Type': 'application/json'
          }
        };
      }
      else {
        requestOptions = {
          method: method,
          withCredentials: true,
          credentials: 'include',
          headers: {
            'Authorization': bearer,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(dataUser)
        };
      }
     
      var result = await fetch(url, requestOptions);


      if (result.status === 500) {
        showError("Error sending declarations");
      } else if (result.status === 404) {
        showError("Error sending declarations");
      }

      else {
        switch (saveOrAddOrDelete) {
          case 'Save':
            showSuccess("Update Successful");
            break;
          case 'Add':
            showSuccess("New record added successfully");
            break;
          case 'Delete':
            showSuccess("Record Deleted");
            break;
          default:
            showSuccess("Update Successful");
        }
      }
    } catch (e) {

      showError();
    } finally {
      reRender = reRender + 1;
      //console.log(reRender);
    }
  }

  const {
    register,
    control,
    setValue,
    handleSubmit,
    clearErrors,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(validationSchema)
  });

  const {
    register: registerSystemAccess,
    control: controlSystemAccess,
    setValue: setValueSystemAccess,
    handleSubmit: handleSubmitSystemAccess,
    clearErrors: clearErrorsSystemAccess,
    formState: { errors: errorsSystemAccess }
  } = useForm({
    resolver: yupResolver(validationSchemaSystemAccess)
  });

  const runValidations = () => {
    debugger;
    validationSchema
      .validate(returnData[0].dataUsers[0], { abortEarly: false })
      .then((responseData) => {
        console.log("no validation errors");
        console.log(responseData);
        console.log(errors);
        //setCurrentErrors([]);
      })
      .catch((err) => {
        console.log(err);
        console.log(err.name); // ValidationError
        console.log(err.errors);
        //setCurrentErrors(err.errors);
      });
  };


  const columns = [
    {
      field: "Actions", width: 210, sortable: false,
      disableExport: 'true',
      renderCell: (cellValues) => {
        return (

          <div>
            {/* {vendorData.userAndTenant.isSuperAdmin && */}
            <Button
              variant="outlined"
              color="primary"
              onClick={(event) => {
                handleClickOpen(event, cellValues, recordData.accessToken);
              }}
            >
              <EditIcon />
            </Button>

            <Button
              variant="outlined"
              color="primary"
              onClick={(event) => {
                handleDeleteOpen(event, cellValues);
              }}
            >
              <DeleteIcon />
            </Button>
            <Tooltip title="Send Declaration to user" arrow>
              <Button
                variant="outlined"
                color="primary"
                onClick={(event) => {
                  sendDeclaration(event, cellValues, recordData.accessToken);
                }}
              >
                <Mail />
              </Button>
            </Tooltip>

          </div>
        );
      }
    },
    { field: 'name', headerName: 'Last Name, First Name', minWidth: 130, flex: 1 },
    { field: 'email', headerName: 'Email', minWidth: 130, flex: 1 },
    { field: 'departmentName', headerName: 'Department', minWidth: 130, flex: 1 },
    {
      field: 'completionStatus', headerName: 'Completion Status', minWidth: 190, flex: 1,
      renderCell: (cellValues) => {
        if (cellValues.row.completionStatus == 0) {
          return (<Typography color={'white'} bgcolor={'red'}  >Incomplete</Typography>)
        }
        else if (cellValues.row.completionStatus == 1) {
          return (<Typography color={'black'} bgcolor={'yellow'}  >In Progress</Typography>)
        }
        else if (cellValues.row.completionStatus == 2) {
          return (<Typography color={'white'} bgcolor={'green'}  >Complete</Typography>)
        }

        else return (<Typography>not specified</Typography>)
      }
    },
    {
      field: 'completionDate', headerName: 'Completion Date', minWidth: 130, flex: 1,

      renderCell: (cellValues) => {
        if (cellValues.row.completionStatus == 2) {
          var compDate = new Date(cellValues.row.completionDate);
          var day = compDate.getDate();
          var month = compDate.getMonth();
          var year = compDate.getFullYear();
          return (<Typography>{day}/{month + 1}/{year}</Typography>)
        }

      }
    }


  ];
  const columnsUserAccess = [
    {
      field: "Actions", width: 150, sortable: false,
      disableExport: 'true',
      renderCell: (cellValues) => {
        return (

          <div>
            {/* {vendorData.userAndTenant.isSuperAdmin && */}
            <Button
              variant="outlined"
              color="primary"
              onClick={(event) => {
                handleUserAccessClickOpen(event, cellValues, recordData.accessToken);
              }}
            >
              <EditIcon />
            </Button>
            {/* } */}

            <Button
              variant="outlined"
              color="primary"
              onClick={(event) => {
                handleUserAccessDeleteOpen(event, cellValues);
              }}
            >
              <DeleteIcon />
            </Button>

          </div>
        );
      }
    },
    { field: 'dataSystemName', headerName: 'System/Module', minWidth: 130, flex: 1 },
    { field: 'dataUserId', headerName: 'id', minWidth: 130, flex: 1, hide: true },
    // { field: 'departmentName', headerName: 'Department', minWidth: 130, flex: 1 },


  ];

  if (requestCode === null) { //all data users
    var returnData = FetchRecords();
    var recordData = returnData[0];
  }
  else { //only the data user with the id
    var returnData = FetchRecord(requestCode);
    var recordData = returnData[0];

  }

  if (requestCode === null) {
    if (recordData && !accessToken) {

      setAccessToken(recordData.accessToken);
      setDepartments(recordData.departments);
      setDataSystems(recordData.dataSystems);
      setDataTypesItems(recordData.dataTypes);

      //console.log(recordData);

    }
  }
  else {

    if (recordData && dataTypesItems.length === 0) {

      setDepartments(recordData.departments);
      setDataSystems(recordData.dataSystems);
      setDataTypesItems(recordData.dataTypes);
      setEditOrAddTitle('Edit Declaration For ');
      debugger;
      setDataSignOff(recordData.dataUsers[0].dataSignOff);
      //open the dialog
      if (recordData.dataUsers.length > 0) {
        setUserValues(recordData.dataUsers[0]);
      }

      setEditOpen(true);

    }

  }

  var loading = returnData[2];
  var error = returnData[1];
  const handleClipboardCopy = () => {
    var currentUrl = window.location.href;
    debugger;
    var url = currentUrl.split('?')[0] + '?id=new&tenantId='+recordData.userAndTenant.tenantId;

    navigator.clipboard.writeText(url);
  
    var spanItem = document.getElementById('copiedMsg');
    //console.log(tooltip);
    spanItem.innerHTML = '&nbsp;&nbsp;&nbsp; Copied!';
  
    setTimeout(function () {
      spanItem.innerHTML = '';
    }, 1000);
  
  };

  const handleClickOpen = (event, cellValues, accessToken) => {

    var dataRow = cellValues.row;
    setFilt([
      {
        columnField: "dataUserId",
        operatorValue: "equals",
        value: dataRow.id.toString()
      }
    ])

    setUserValues(dataRow);
    setEditOpen(true);

  };

  const sendDeclaration = (event, cellValues, accessToken) => {
    var dataRow = cellValues.row;
    saveDataUser(dataRow, 'Send', accessToken);  //send declaration
  }
  const sendAllDeclarations = () => {
    //saveDataUser(null, 'SendAll', recordData.accessToken);  //send declaration
    setDeclarationOpen(true);
  }

  const handleUserAccessClickOpen = (event, cellValues, accessToken) => {

    var dataRow = cellValues.row;

    //setValue("id", dataRow.id);


    setValue("dataSystemId", dataRow.dataSystemId);
    setValueSystemAccess("dataSystemId", dataRow.dataSystemId);
    setValue("dataUse", dataRow.dataUse);
    setValue("dataRetention", dataRow.dataRetention);
    setDataTypesSelected(dataRow.selectedDataTypes);
    //setValue("dataTypesSelected", dataRow.dataTypesSelected);
    setValue("dataSignoff", dataRow.dataSignOff);
    setDataSignOff(dataRow.dataSignOff);

    //console.log(recordData.departments);
    setEditOrAddTitle('Edit');
    setDataAccessOpen(true);

  };

  const addDataUser = (event, cellValues) => {

    setValue("id", -1);
    setValue("firstName", '');
    setValue("lastName", '');
    setValue("email", '');
    setValue("departmentId", '');
    setEditOpen(true);
    setEditOrAddTitle('Add');
    setFilt([
      {
        columnField: "dataUserId",
        operatorValue: "equals",
        value: "-1"
      }
    ])
    clearErrors();
    setOpen(true);

  };

  const addSystemAccess = (data) => {

    setValue("systemAccessId", -1);
    setValueSystemAccess("dataSystemId", null);
    setValue("dataSystemId", null);
    setValueSystemAccess("dataUse", '');
    setValue("dataUse", '');
    setValueSystemAccess("dataRetention", '');
    setValue("dataRetention", '');
    setDataTypesSelected([]);
    setDataSignOff(false);
    setEditOrAddTitle('Add');

    clearErrors();
    setDataAccessOpen(true);
  }


  const handleDeleteOpen = (event, cellValues) => {

    var dataRow = cellValues.row;
    setDeleteName(dataRow.name);
    setDeleteId(dataRow.id)
    setDeleteOpen(true);
  };

  const handleUserAccessDeleteOpen = (event, cellValues) => {
    var dataRow = cellValues.row;
    setDeleteName(dataRow.name);
    setDeleteId(dataRow.id)
    setDeleteOpen(true);
  };

  const handleCancel = (event, reason) => {

    if (reason && reason === "backdropClick")
      return;
    setEditOpen(false);
    reRender = reRender + 1; //this is to force a re-render/refresh of the data
  };

  const handleDataAccessCancel = (event, reason) => {
    if (reason && reason === "backdropClick")
      return;
    //to do - any changes here should not be saved if the user saves the main page
    setDataAccessOpen(false);
  };

  const handleDeleteCancel = () => {
    setDeleteOpen(false);
  };

  const handleDeclarationCancel = () => {
    setDeclarationOpen(false);
  };
  const handleDeclaration = () => {
    setDeclarationOpen(false);
    saveDataUser(null, 'SendAll', recordData.accessToken);  //send declaration
  };

  const handleDelete = () => {
    var data = { id: deleteId };
    // data.id = deleteId;

    saveDataUser(data, 'Delete', accessToken);
    reRender = reRender + 1;
    setDeleteOpen(false);
  };
  const closeSuccess = () => {
    setSuccessOpen(false);
  };
  const closeError = () => {
    setErrorOpen(false);
  };

  const titleBoxBackgroundColour = '#1976d21a';

  const handleDepartmentChange = (event, cloudProviderOtherValue) => {
    setValue('departmentId', event.target.value, { shouldValidate: true });
  }

  const handleSystemUserChange = (event) => {
    //TODO:need to figure this out
    setValueSystemAccess('dataSystemId', event.target.value, { shouldValidate: true });
    setValue('dataSystemId', event.target.value, { shouldValidate: true });
  }
  if (loading) {
    return (
      // <div>
      //   Loading...
      // </div>

      <DarkBackground >
        <LoadingOverlay
          active={true}

          spinner={true}
          text="Loading..."
        >
        </LoadingOverlay>
      </DarkBackground>

    )
  } else if (loading === false && error !== null) {
    return (
      <Stack spacing={2}>
        <Alert severity="error">Error occured loading data users</Alert>
      </Stack>

    )
  }

  return (
    <div>
      <SuccessError
        successMessage={successMessage}
        errorMessage={errorMessage}
        closeError={() => closeError()}
        closeSuccess={() => closeSuccess()}
        successOpen={successOpen}
        errorOpen={errorOpen}
      >
      </SuccessError>
      {(requestCode === null) && (<>

        <Box
          component="span"
          m={1}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="h3" component="h2">
            Data Users
          </Typography>
          <Button variant="outlined" onClick={sendAllDeclarations} sx={{ marginLeft: "auto" }} >Send Yearly Declaration</Button>
          <Button variant="outlined" onClick={addDataUser}>Add Data User</Button>
        </Box>
      </>
      )}
      <div>

        <div style={{ height: '70vh', width: '100%' }}>
          {(requestCode === null) && (<>

            <DataGrid
              //componentsProps={{ toolbar: { csvOptions: { allColumns: true } } }} 
              fullWidth

              components={{
                Toolbar: CustomToolbar,
              }}
              initialState={{
                pagination: {
                  pageSize: 1000,
                },
              }}
              height='100%'
              rows={recordData.dataUsers}
              columns={columns}
              //pageSize={100}
              rowsPerPageOptions={[50, 100]}
            //checkboxSelection
            />
          </>
          )}
        </div>
        <div>
      
          <Tooltip id='newToolTip' title='Click to copy URL to send to a NEW user to fill out info'>
            <Button onClick={handleClipboardCopy}>Click to copy URL for new User &nbsp;<ContentCopyIcon  ></ContentCopyIcon> <span id='copiedMsg'></span></Button>
          </Tooltip>
        </div>

        <Dialog open={dataAccessOpen} onClose={handleDataAccessCancel} maxWidth="md" fullWidth
          scroll={'paper'}
        >

          <DialogTitle
            sx={{ padding: "3px 39px" }}
          >{editOrAddTitle} Data System Access
            <Typography variant="inherit" sx={{ fontSize: 12, paddingLeft: 2, color: "grey" }} display='inline'>
              * = required
            </Typography>

          </DialogTitle>

          <DialogContent>
            <Box sx={{ border: 1, backgroundColor: titleBoxBackgroundColour }} px={2} py={1}
              onClick={() => setGeneralOpen(!generalOpen)}
            >
              <Grid container sx={{ justifyContent: "space-between" }} >
                <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                  Data System Access
                </Typography>
                <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                  {generalOpen ? <RemoveIcon /> : <AddIcon />}
                </Typography>

              </Grid>
            </Box>


            <Collapse in={generalOpen} width={'100%'}>
              <Box sx={{ border: 1 }} px={2} py={1}>
                <Fragment>
                  <Grid container spacing={1}>

                    <Grid item xs={12} sm={12}>
                      <TextField
                        required
                        id="id"
                        name="id"
                        label="ID"
                        fullWidth
                        hidden
                        margin="dense"
                        {...registerSystemAccess('id')}

                      />

                    </Grid>
                    <Grid item xs={8} sm={8}>
                      <FormControl sx={{ m: 0, minWidth: 450, paddingTop: 1 }}>

                        <InputLabel sx={{ paddingTop: 1.5 }}>System and Module</InputLabel>
                        <Controller
                          name="dataSystemId"
                          control={controlSystemAccess}

                          render={({ field: { onChange, value } }) => (
                            <Select id='dataSystemId'
                              value={value}
                              {...registerSystemAccess('dataSystemId')}
                              label="Data System and Module"
                              onChange={e => handleSystemUserChange(e)}
                            >
                              {dataSystems.map((item, index) => <MenuItem key={index} value={item.id}>{item.system} - {item.module}</MenuItem>)}

                            </Select>
                          )} />
                      </FormControl>
                      <Typography variant="inherit" color="error.main">
                        {errors.cloudProviderId?.message}
                      </Typography>
                    </Grid>
                    <Grid item xs={5} sm={5}>
                      <MultiSelectWithChips
                        label="Data Types"
                        name="dataTypesSelected"
                        control={controlSystemAccess}
                        value={dataTypesSelected}
                        infoSelected={dataTypesSelected}
                        //infoNASelected={studentInfoNASelected}
                        setinfoSelected={setDataTypesSelected}
                        onChange={handleDataTypesChange}
                        handleChipDelete={handleChipDeleteForDataTypes}
                        errors={errors.dataTypes}

                        items={dataTypesItems}
                      >
                      </MultiSelectWithChips>


                      <Typography variant="inherit" color="error.main">
                        {errors.departmentsSelected?.message}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <TextField
                        //required
                        control={control}
                        InputLabelProps={{ shrink: true }}
                        placeholder='Describe the ways in which you use this data.'
                        id="dataUse"
                        name="dataUse"
                        label="Data Use"
                        fullWidth
                        margin="dense"
                        {...register('dataUse')}
                        error={errors.dataUse ? true : false}
                      />
                      <Typography variant="inherit" color="error.main">
                        {errors.dataUse?.message}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <TextField
                        //required
                        control={control}
                        InputLabelProps={{ shrink: true }}
                        placeholder='Describe how long this data is kept active.'
                        id="dataRetention"
                        name="dataRetention"
                        label="Data Retention"
                        fullWidth
                        margin="dense"
                        {...register('dataRetention')}
                        error={errorsSystemAccess.dataRetention ? true : false}
                      />
                      <Typography variant="inherit" color="error.main">
                        {errors.dataRetention?.message}
                      </Typography>
                    </Grid>
                    <Grid item xs={6} sm={6} md={6}>
                      <FormGroup>
                        <FormControlLabel control={<Checkbox checked={dataSignoff} onChange={handleDataSignoffChange} />} label="Data Sign-off" />

                      </FormGroup>
                      <Typography variant="inherit" color="error.main">
                        {errors.dataSignOff?.message}
                      </Typography>
                    </Grid>
                  </Grid>
                </Fragment>
              </Box>
            </Collapse>
          </DialogContent>

          <DialogActions>

            <Button color="primary" onClick={handleSubmit(onSubmitSystemAccess)}>Save</Button>

            <Button onClick={handleDataAccessCancel}>Cancel</Button>

          </DialogActions>

        </Dialog>

        <Dialog open={editOpen} onClose={handleCancel} maxWidth="md" fullWidth
          scroll={'paper'}
        >

          <DialogTitle
            sx={{ padding: "3px 39px" }}
          >{editOrAddTitle} Data User
            <Typography variant="inherit" sx={{ fontSize: 12, paddingLeft: 2, color: "grey" }} display='inline'>
              * = required
            </Typography>

          </DialogTitle>

          <DialogContent>
            <SuccessError

              errorMessage={errorMessage}
              closeError={() => closeError()}
              closeSuccess={() => closeSuccess()}

              errorOpen={errorDialogOpen}
            >
            </SuccessError>
            <Fragment>
              <Paper variant="outlined" >
                <Box sx={{ border: 1, backgroundColor: titleBoxBackgroundColour }} px={2} py={1}
                  onClick={() => setGeneralOpen(!generalOpen)}
                >
                  <Grid container sx={{ justifyContent: "space-between" }} >
                    <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                      Data User
                    </Typography>
                    <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                      {generalOpen ? <RemoveIcon /> : <AddIcon />}
                    </Typography>

                  </Grid>
                </Box>


                <Collapse in={generalOpen} width={'100%'}>
                  <Box sx={{ border: 1 }} px={1} py={2}>
                    <Grid container spacing={1}>

                      <Grid item xs={12} sm={12}>
                        <TextField
                          required
                          id="id"
                          name="id"
                          label="ID"
                          fullWidth
                          hidden
                          margin="dense"
                          {...register('id')}

                        />

                      </Grid>
                      <Grid item xs={3} sm={3}>
                        <TextField
                          required
                          InputLabelProps={{ shrink: true }}
                          placeholder="First Name"
                          id="firstName"
                          name="firstName"
                          label="First Name"
                          fullWidth
                          margin="dense"
                          {...register('firstName')}
                          error={errors.firstName ? true : false}
                        />
                        <Typography variant="inherit" color="error.main">
                          {errors.firstName?.message}
                        </Typography>
                      </Grid>
                      <Grid item xs={3} sm={3}>
                        <TextField
                          required
                          InputLabelProps={{ shrink: true }}
                          placeholder="Last Name"
                          id="lastName"
                          name="lastName"
                          label="Last Name"
                          fullWidth
                          margin="dense"
                          {...register('lastName')}
                          error={errors.lastName ? true : false}
                        />
                        <Typography variant="inherit" color="error.main">
                          {errors.lastName?.message}
                        </Typography>
                      </Grid>
                      <Grid item xs={6} sm={6}>
                        <TextField
                          required
                          InputLabelProps={{ shrink: true }}
                          placeholder="Email"
                          id="email"
                          name="email"
                          label="Email"
                          fullWidth
                          margin="dense"
                          {...register('email')}
                          error={errors.email ? true : false}
                        />
                        <Typography variant="inherit" color="error.main">
                          {errors.email?.message}
                        </Typography>
                      </Grid>
                      <Grid item xs={4} sm={4}>
                        <FormControl sx={{ m: 0, minWidth: 200, paddingTop: 1 }}>

                          <InputLabel sx={{ paddingTop: 1.5 }}>Department</InputLabel>
                          <Controller
                            name="departmentId"
                            control={control}

                            render={({ field: { onChange, value } }) => (
                              <Select id='departmentId'
                                value={value}
                                label="Department"
                                onChange={e => handleDepartmentChange(e)}
                              >
                                {departments.map((mode, index) => <MenuItem key={index} value={mode.lookupItemId}>{mode.name}</MenuItem>)}

                              </Select>
                            )} />
                        </FormControl>
                        {/* <Button variant="outlined" sx={{ marginLeft: "auto" }} onClick={runValidations}>Validate</Button> */}
                        <Typography variant="inherit" color="error.main">
                          {errors.cloudProviderId?.message}
                        </Typography>
                      </Grid>
                      {(requestCode !== null) && (<> <Grid item xs={12} sm={12}>
                        <FormGroup>
                          <FormControlLabel control={<Checkbox checked={dataSignoff} onChange={handleDataSignOffChange} />} label="By checking this box you agree to follow all of the policies and procedures at the school in relation to data privacy, including but not limited to, ensure that no private school data is downloaded onto personal devices, and that you will only access the data required to perform your duties in your role at the school." />

                        </FormGroup>
                        <Typography variant="inherit" color="error.main">
                          {errors.dataUse?.message}
                        </Typography>
                      </Grid>
                      </>)}



                    </Grid>
                  </Box>
                </Collapse>
                <Box sx={{ border: 1, backgroundColor: titleBoxBackgroundColour }} px={2} py={1}
                  onClick={() => setDataAccessOpen(!dataAccessOpen)}
                >
                  <Grid container sx={{ justifyContent: "space-between" }} >
                    <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                      Data User System Access
                    </Typography>
                    <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                      {systemAccessOpen ? <RemoveIcon /> : <AddIcon />}
                    </Typography>

                  </Grid>
                </Box>
                <Collapse in={systemAccessOpen} width={'100%'}>
                  <Box sx={{ border: 1 }} px={1} py={2}>
                    <Grid container spacing={1}>
                      <Button variant="outlined" sx={{ marginLeft: "auto" }} onClick={addSystemAccess}>Add System Access</Button>
                      <Grid item xs={12} sm={12} height={500}>
                        <DataGrid
                          filterModel={{
                            items: filt
                          }}
                          fullWidth


                          initialState={{
                            pagination: {
                              pageSize: 1000,
                            },
                          }}
                          height='100%'
                          rows={recordData.dataSystemUsers}
                          columns={columnsUserAccess}
                          //pageSize={100}
                          rowsPerPageOptions={[50, 100]}
                        //checkboxSelection
                        />

                      </Grid>
                    </Grid>
                  </Box>
                </Collapse>
              </Paper>
            </Fragment>
          </DialogContent>

          <DialogActions>
            {(requestCode === null) && (<>
              <Button color="primary" onClick={handleSubmit(onSubmit)}>Save</Button>
              <Button onClick={handleCancel}>Cancel</Button>
            </>)}
            {(requestCode !== null) && (<>
              <Button color="primary" variant="outlined" onClick={handleSubmit(onSubmitComplete)}>Save and Complete</Button>
              {/* <Button color="primary" variant="outlined" onClick={handleSubmit(onSubmitInProgress)}>Save and Finish Later</Button> */}
              <Button variant="outlined" onClick={handleCancel}>Cancel</Button>
            </>)}
          </DialogActions>


        </Dialog>

        <Dialog open={deleteOpen} onClose={handleDeleteCancel}>
          <DialogTitle>Delete Data User</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you wish to Delete <strong>{deleteName} ?</strong>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button color="primary" onClick={handleDelete}>Delete</Button>
            <Button onClick={handleDeleteCancel}>Cancel</Button>
          </DialogActions>
        </Dialog>

        <Dialog open={declarationOpen} onClose={handleDeclarationCancel}>
          <DialogTitle>Send Declarations</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you wish to send declaration emails?  This will send to all users on this list and reset the completion status until the user completes the form.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button color="primary" onClick={handleDeclaration}>Send Declarations</Button>
            <Button onClick={handleDeclarationCancel}>Cancel</Button>
          </DialogActions>
        </Dialog>

      </div>

    </div>


  );

}